import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=6482308c&scoped=true"
import script from "./DeleteIcon.vue?vue&type=script&lang=ts"
export * from "./DeleteIcon.vue?vue&type=script&lang=ts"
import style0 from "./DeleteIcon.vue?vue&type=style&index=0&id=6482308c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6482308c",
  null
  
)

export default component.exports